import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Campaigns from "./Campaigns";
import Winners from "./Winners";
import SmallFaq from "../SmallFaq";
import axios from "axios";
import ResponsiveContainer from "../../components/ResponsiveContainer";
import SpecialBanner from "../../../images/edscap-campanha-web.png";
import SpecialBannerMobile from "../../../images/edscap-campanha-mob.png";
import CompleteProfileEmailModal from "../../components/CompleteProfileEmailModal";
import InstantWinnerToast from "../../components/InstantWinnerToast";

const COMPLETE_PROFILE_MODAL_DAY_KEY = 'cap_complete_profile_email_modal_day';

function todayLocalYmd() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export default function Home({ currentUser, influencer, isMobile }) {
  const history = useHistory();
  const [campaigns, setCampaigns] = useState([]);
  const [loadingCampaigns, setLoadingCampaigns] = useState(true);

  const [winners, setWinners] = useState([]);
  const [loadingWinners, setLoadingWinners] = useState(true);

  const [completeProfileModalOpen, setCompleteProfileModalOpen] = useState(false);

  useEffect(() => {
    fetchCampaigns();
    fetchWinners();
  }, []);

  useEffect(() => {
    if (!currentUser || !currentUser.needs_email_completion) {
      setCompleteProfileModalOpen(false);
      return;
    }
    if (typeof localStorage === 'undefined') {
      setCompleteProfileModalOpen(true);
      return;
    }
    const today = todayLocalYmd();
    const lastShownDay = localStorage.getItem(COMPLETE_PROFILE_MODAL_DAY_KEY);
    if (lastShownDay === today) {
      setCompleteProfileModalOpen(false);
      return;
    }
    localStorage.setItem(COMPLETE_PROFILE_MODAL_DAY_KEY, today);
    setCompleteProfileModalOpen(true);
  }, [currentUser]);

  async function fetchCampaigns() {
    try {
      const response = await axios.get(`/api/v1/campaigns/${influencer.username}/home.json`);
      setCampaigns(response.data || []);
    } catch (error) {
      setCampaigns([]);
    } finally {
      setLoadingCampaigns(false);
    }
  }

  async function fetchWinners() {
    try {
      const response = await axios.get(`/api/v1/campaigns/${influencer.username}/drawn_tickets.json`);
      setWinners(response.data || []);
    } catch (error) {
      setWinners([]);
    } finally {
      setLoadingWinners(false);
    }
  }

  function handleCloseCompleteProfileModal() {
    setCompleteProfileModalOpen(false);
  }

  function handleEditProfileFromModal() {
    setCompleteProfileModalOpen(false);
    const base = influencer?.username ? `/${influencer.username}/site/change_profile` : '/site/change_profile';
    history.push(base);
  }

  return (
    <ResponsiveContainer>
      <InstantWinnerToast influencer={influencer} />
      <CompleteProfileEmailModal
        open={completeProfileModalOpen}
        onClose={handleCloseCompleteProfileModal}
        onEditProfile={handleEditProfileFromModal}
      />
      {/* Banner temporariamente desabilitado
      { (influencer.username == 'jojo' || influencer.username == 'virginia' || influencer.username == 'gicely' || influencer.username == 'edscap') && (
        <img src={isMobile ? SpecialBannerMobile : SpecialBanner} style={{width: '100%'}} />
      )}
      */}
      <Campaigns campaigns={campaigns} loading={loadingCampaigns} influencer={influencer} currentUser={currentUser} />
      <SmallFaq />
      <Winners winners={winners} loadingWinners={loadingWinners} influencer={influencer} currentUser={currentUser} />
    </ResponsiveContainer>
  );
}
